/** Query keys for the document-imports cache namespace. */
export const documentImportKeys = {
  all: ['document-imports'] as const,
  list: (scope = 'document-imports') =>
    ['document-imports', scope, 'list'] as const,
};
